<ion-content>
    <ion-fab vertical="top" horizontal="start" slot="fixed">
        <ion-icon name="arrow-round-back" class="close-fab" (click)="goBack()"></ion-icon>
    </ion-fab>
    <div class="page-background-blue">
        <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
            <ion-grid class="ion-no-padding details-wrapper">
                <ion-row class="page-padding">
                    <h1 class="header-text">Reset password</h1>
                </ion-row>
                <ion-row class="user-details-table">
                    <ion-item class="splitter-line-bottom">
                        <ion-col size="5" class="ion-no-margin">
                            <h1 class="details-heading">Current Password</h1>
                        </ion-col>
                        <ion-col size="7" class="ion-no-margin input-container">
                            <input class="user-details" [type]="currentPasswordType" placeHolder="Enter current password" formControlName="currentPassword">
                            <ion-icon [name]="currentPasswordIcon" class="passwordIcon passwordIcon-alignment" (click)="toggleViewPassword('current')"></ion-icon>
                        </ion-col>
                    </ion-item>

                    <ion-item class="splitter-line-bottom">
                        <ion-col size="5" class="ion-no-margin">
                            <h1 class="details-heading">New Password</h1>
                        </ion-col>
                        <ion-col size="7" class="ion-no-margin input-container">
                            <input class="user-details" [type]="newPasswordType" placeHolder="Enter new password" formControlName="newPassword">
                            <ion-icon item-right [name]="newPasswordIcon" class="passwordIcon passwordIcon-alignment" (click)="toggleViewPassword('new')"></ion-icon>
                        </ion-col>
                    </ion-item>

                    <ion-item class="splitter-line-bottom">
                        <ion-col size="5" class="ion-no-margin">
                            <h1 class="details-heading">Confirm Password</h1>
                        </ion-col>
                        <ion-col size="7" class="ion-no-margin input-container">
                            <input class="user-details" [type]="repeatPasswordType" placeHolder="Confirm new password" formControlName="confirmPassword">
                            <ion-icon item-right [name]="repeatPasswordIcon" class="passwordIcon passwordIcon-alignment" (click)="toggleViewPassword('repeat')"></ion-icon>
                        </ion-col>
                    </ion-item>
                </ion-row>
            </ion-grid>
            <div>
                <ion-button expand="block" color="secondary" class="capsule-btn btn-reset" type="submit">Confirm</ion-button>
            </div>
        </form>
    </div>
</ion-content>